/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, createRef } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Typography, Tooltip, Button, message, Upload, Empty, Modal } from 'antd';
import ResponsiveBreadcrumb from '../../components/breadcrumb/ResponsiveBreadcrumb';
import { UploadOutlined } from '@ant-design/icons';
import './MasteryAssessment.css';
import SimpleBarReact from "simplebar-react";
import '../../../node_modules/simplebar/src/simplebar.css';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import StickyBox from "react-sticky-box";
import axios from 'axios';
// import uuid from 'react-uuid';
import { useSelector, useDispatch } from 'react-redux';

// import AllPagesPDFViewer from '../../components/pdf-viewer/all-pages';
// import RenderPDFViewer from '../../components/iframe-viewer/pdfViewer';
// import { PDFReader } from 'reactjs-pdf-reader';
import BraineeQuestionCard from '../../components/assessment/BraineeQuestionCard';
import MasteryAssessmentToolsM from '../../components/assessment/MasteryAssessmentToolsM';
// import { CardRequestHelper } from './Helpers';
import {
   CardRequestHelper,
   getLocalStorageData,
   setLocalStorageData,
   removeLocalStorageKeys,
   createAssessmentPayload,
   validateAssessmentFields,
   showValidationModal,
   toggleAssignmentViews
} from '../../helper/AQHelper';

import Split from 'react-split';
// import './SplitPanel.css';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';

import { update_mastery_data } from '../../actions';

// import { RenderPDFReader } from '../../components/pdfreader/RenderPDFReader';
import { BrowserView, MobileView } from 'react-device-detect';
import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import { getAssetSubdomain } from '../../services/apiClient';

const { Text } = Typography;
var pdfFile = '';

let sectionIdx = 1;
let qcardIdx = 1;
let idxCol = [];
let tempAssOptions = null;
let defaultAssOptions = {
   id: '',
   assessment_id: '',
   assigned_by: '1',
   duration: '1',
   allowed_attempts: '1',
   passing_percentage: '50',
   allow_result_viewing: '0',
   enable_timer: '0',
   start_date: '',
   end_date: '',
   assigned_students: '',
   term: ''
}

export function MasteryCreatePDF(props) {
   const location = useLocation();
   const navigate = useNavigate();
   const dispatch = useDispatch();

   const masteryrec = useSelector(state => state.masteryrec);
   const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);
   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);

   const [answerSheetData, setAnswerSheetData] = useState(() =>
      getLocalStorageData("mastery_asd", [])
   );
   const [questionSheetPDF, setQuestionSheetPDF] = useState("");
   const [showAssessmentSheet, setShowAssessmentSheet] = useState(true);
   const [assOptions, setAssOptions] = useState(() =>
      getLocalStorageData("mastery_options", defaultAssOptions)
   );

   const [assInfo, setAssInfo] = useState({
      Id: "",
      Title: location.state.title,
      Level: "",
      Mastery_level: "",
      Subject: "",
      File_url: "",
      Question_type: "1",
      Created_by: "",
      Date_created: "",
      Question_sheet: "",
   });

   const [pdfLoaded, setPdfLoaded] = useState(false);

   const subdomain = getAssetSubdomain();

   const [shouldScroll, setShouldScroll] = useState();
   const qtEndRef = createRef();

   useEffect(() => {
      Utils.verifyJwt();

      // if (user_role.toLowerCase() !== 'admin')
      const allowedRoles = ['super admin', 'admin'];
      if (!allowedRoles.includes(user_role.toLowerCase()))
         navigate('/home');

      pdfFile = '';

      // switch (location.state.type) {
      //    case "formative_1":
      //       setQuestionSheetPDF(masteryrec.formative_1_file_url);
      //       break;
      //    case "formative_2":
      //       setQuestionSheetPDF(masteryrec.formative_2_file_url);
      //       break;
      //    case "formative_3":
      //       setQuestionSheetPDF(masteryrec.formative_3_file_url);
      //       break;
      //    case "summative":
      //       setQuestionSheetPDF(masteryrec.summative_file_url);
      //       break;
      //    default:
      //       setQuestionSheetPDF("");
      // }
   }, []);

   useEffect(() => {
      scrollToBottom();
   }, [shouldScroll]);

   const scrollToBottom = () => {
      qtEndRef.current?.scrollIntoView({ behavior: 'smooth' });
   }

   const handleOnDragEnd = (result) => {
      if (!result.destination) return;

      const items = Array.from(answerSheetData);
      const [reorderedItem] = items.splice(result.source.index, 1);
      items.splice(result.destination.index, 0, reorderedItem);

      setAnswerSheetData(items);

      sectionIdx = 1;
      qcardIdx = 1;
      idxCol = [];
   };

   // Unified card request handler
   const handleCardRequest = (method, type, data, idx, template) => {
      const updated = CardRequestHelper(method, type, data, idx, answerSheetData, template);
      setAnswerSheetData(updated);
      removeLocalStorageKeys(["mastery_asd", "mastery_options"]);
      if (method === 'add' || method === 'duplicate')
         setShouldScroll(updated);
      sectionIdx = 1;
      qcardIdx = 1;
      idxCol = [];
   };

   const handleUpload = (file) => {
      const key = 'updatable';
      message.loading({ content: 'Uploading your document...', key, duration: 0 });

      const formData = new FormData();
      formData.append('file', file);

      const url = `${process.env.REACT_APP_API_S3_UPLOAD}/uploadMasteryFile?s3path=${process.env.REACT_APP_S3_MASTERY_ASSESSMENT_QUESTIONAIRE_PATH}`;
      axios.post(url, formData).then(response => {
         console.log(response);
         if (response.data) {
            const data = response.data;
            // var params = {key: location.state.type + '_file_url', value : `${process.env.REACT_APP_API_S3_URL}/${data}`};
            var params = { key: location.state.type + '_file_url', value: `${data}` };
            dispatch(update_mastery_data(params));

            setQuestionSheetPDF(`${process.env.REACT_APP_API_S3_URL}/${subdomain}/${data}`);
         }

         setTimeout(() => {
            message.success({ content: 'File uploaded!', key, duration: 2 });
         }, 1000);
      }, (error) => {
         console.log(error.message);
         // setTimeout(key, 100);
         setTimeout(() => {
            message.error({ content: 'File upload failed!', key, duration: 2 });
         }, 1000);
      });

      // const formData = new FormData();
      // formData.append('file', file);

      // Utils.getBase64(file, pdfb64 => {
      //    var params = { key: location.state.type + '_file_url', value: `${pdfb64}` };
      //    dispatch(update_mastery_data(params));
      //    setQuestionSheetPDF(pdfb64);
      // });
   }

   const UploadPdf = () => {
      const props = {
         beforeUpload: file => {
            const isPDF = file.type === 'application/pdf';
            if (!isPDF) {
               message.error(`Only PDF files can be uploaded`);
            }
            //return isPDF || Upload.LIST_IGNORE;
            handleUpload(file);
         },
      };
      return (
         <Upload {...props} showUploadList={false} accept=".pdf">
            <Tooltip placement="left" title='Upload questionaire in PDF format'>
               <Button className='button-shadow' type="primary" size="middle" shape='round'>
                  <Text ellipsis style={{ color: "#fff" }}><UploadOutlined />&nbsp;Upload Questionaire</Text>
               </Button>
            </Tooltip>
         </Upload>
      );
   };

   // Save Assessment Section
   const handleSave = () => {
      if (answerSheetData.length > 0 && (questionSheetPDF !== '' && questionSheetPDF !== null)) {
         removeLocalStorageKeys(['mastery_asd', 'mastery_options']);
         var params = { key: location.state.type, value: JSON.stringify(answerSheetData) };
         dispatch(update_mastery_data(params));
         if (location.state.mode === 'create')
            navigate('/masteryassessment/create?qt=1');
         else
            navigate(`/masteryassessment/edit?id=${masteryrec.id}&subject=${location.state.subjectid}&subjectname=${location.state.subjectname}`);
      } else {
         Modal.info({
            title: 'Mastery Assessment',
            content: (
               <>
                  Please complete the folowing before saving.
                  <ul>
                     <li>
                        Upload questionaire
                     </li>
                     <li>
                        Answer keys
                     </li>
                  </ul>
               </>),
            centered: true,
         });
      }
   };

   function sPDFFile() {
      pdfFile = questionSheetPDF;
      return true;
   }

   return (
      <>
         <div className="dashboard-area-all" style={{ paddingRight: `0px` }}>
            <Split
               sizes={[60, 40]}
               direction="horizontal"
               cursor="col-resize"
               className="split-flex"
            >
               <div>
                  <div className="dashboard-item">
                     <div className="dashboard-item-inner">
                        {/* <ul>
                           <li><a href="#" onClick={() => navigate('/home')}>Home</a></li>
                           <li><span>/</span></li>
                           <li className="active">Brainee LMS</li>
                           <li><span>/</span></li>
                           <li><a href="#" onClick={() => navigate('/masterysubjects')}>Mastery Subjects</a></li>
                           {location.state.mode === 'edit'
                              ?
                              <>
                                 <li><span>/</span></li>
                                 <li><a href="#" onClick={() => navigate(`/masteryassessmentsubject?id=${location.state.subjectid}&name=${location.state.subjectname}`)}>Mastery Assessment ({location.state.subjectname})</a></li>
                              </>
                              :
                              <></>
                           }
                           <li><span>/</span></li>
                           {location.state.mode === 'create'
                              ?
                              <li><a href="#" onClick={() => navigate('/masteryassessment/create?qt=1')}>Create</a></li>
                              :
                              <li><a href="#" onClick={() => navigate(`/masteryassessment/edit?id=${masteryrec.id}&subject=${location.state.subjectid}&subjectname=${location.state.subjectname}`)}> Edit</a></li>
                           }

                           <li><span>/</span></li>
                           <li><a className="active">{location.state.title} (Create)</a></li>
                        </ul> */}
                        <ResponsiveBreadcrumb
                           style={{ paddingBottom: '15px' }}
                           items={[
                              { key: 'home', node: <Link to="/home">Home</Link> },
                              { key: 'lms', node: 'Brainee LMS' },
                              { key: 'mastery-subject', node: <a href="#" onClick={() => navigate('/masterysubjects')}>Mastery Subject</a> },
                              ...(location.state.mode === 'edit'
                                 ? [{ key: 'mastery-assessment-subject', node: <a href="#" onClick={() => navigate(`/masteryassessmentsubject?id=${location.state.subjectid}&name=${location.state.subjectname}`)}>Mastery Assessment ({location.state.subjectname})</a> }]
                                 : []),
                              {
                                 key: 'mode-action',
                                 node: location.state.mode === 'create'
                                    ? <a href="#" onClick={() => navigate('/masteryassessment/create?qt=2')}>Create</a>
                                    : <a href="#" onClick={() => navigate(`/masteryassessment/edit?id=${masteryrec.id}&subject=${location.state.subjectid}&subjectname=${location.state.subjectname}`)}> Edit</a>
                              },
                              { key: 'title-create', node: `${location.state.title} (Create)` },
                           ]}
                        />
                     </div>

                     <div className="pdf-all-page-container" style={{ height: 'calc(100vh - 90px)' }}>
                        {/* <SimpleBarReact> */}
                        <StickyBox style={{ zIndex: 1000 }}>
                           <div style={{ textAlign: "right" }}>{UploadPdf()}</div>
                        </StickyBox>
                        {
                           questionSheetPDF === "" || questionSheetPDF === null
                              ?
                              <Empty description="You have not yet uploaded your questionaire" style={{ position: "relative" }} />
                              :
                              <>
                                 <div style={{ width: "100%", height: "calc(100vh - 90px)" }}>
                                    <Worker workerUrl={process.env.PUBLIC_URL + "/js/pdf.worker.min.js"}>
                                       <Viewer
                                          pageLayout={{
                                             transformSize: ({ size }) => ({
                                                height: size.height + 30,
                                                width: size.width + 30,
                                             }),
                                          }}
                                          fileUrl={questionSheetPDF}
                                          defaultScale={SpecialZoomLevel.PageWidth}
                                          initialPage={0}
                                       />
                                    </Worker>
                                 </div>
                                 {/* <BrowserView>
                                    <object data={`${process.env.REACT_APP_API_S3_URL}/${questionSheetPDF}`} width="100%" style={{ height: 'calc(100vh - 90px)' }}>
                                       <p>Brainee LMS PDF - View<a href={`${process.env.REACT_APP_API_S3_URL}/${questionSheetPDF}`}> PDF!</a></p>
                                    </object>
                                 </BrowserView>
                                 <MobileView>
                                    <div style={{ width : "100%", height:"calc(100vh - 90px)" }}>
                                       <Worker workerUrl={process.env.PUBLIC_URL + "/js/pdf.worker.min.js"}>
                                          <Viewer 
                                             pageLayout={{transformSize: ({ size }) => ({
                                                height: size.height + 30,
                                                width: size.width + 30,
                                             }),}}  
                                             fileUrl={`${process.env.REACT_APP_API_S3_URL}/${questionSheetPDF}`}  
                                             defaultScale={SpecialZoomLevel.PageWidth}   
                                             initialPage={0} 
                                          />
                                       </Worker>
                                    </div>
                                 </MobileView> */}
                              </>
                           // <object data={questionSheetPDF} width="100%" style={{ height: 'calc(100vh - 90px)' }}>
                           //    <p>Brainee LMS PDF - <a href={questionSheetPDF}> Show PDF</a></p>
                           // </object>
                           // <RenderPDFViewer url={questionSheetPDF} height={"calc(100vh - 90px)"} load={pdfFile !== questionSheetPDF ? sPDFFile() : false} />
                        }
                        {/* </SimpleBarReact> */}
                     </div>
                  </div>
               </div>

               <div>
                  <div className="notice-item">

                     {showAssessmentSheet &&
                        <>
                           <div className='answer-sheet-content'>
                              <SimpleBarReact>
                                 <StickyBox style={{ zIndex: 1000 }}>
                                    <MasteryAssessmentToolsM
                                       key={"createPDF"}
                                       data={assInfo}
                                       cardRequestCallback={handleCardRequest}
                                       saveCallback={handleSave}
                                       showToggle={true}
                                       mode={"create"}
                                       type={'pdf'}
                                    />
                                 </StickyBox>

                                 <DragDropContext onDragEnd={(e) => handleOnDragEnd(e)}>
                                    <Droppable droppableId="questions">
                                       {(provided) => (
                                          <ul className="questions" {...provided.droppableProps} ref={provided.innerRef}>
                                             {answerSheetData.map(({ id, type, points, correct, option_labels, image_url }, idx) => {

                                                if (type === "section") {
                                                   qcardIdx = 1;
                                                   idxCol.push(sectionIdx);
                                                   sectionIdx++;
                                                } else {
                                                   idxCol.push(qcardIdx);
                                                   qcardIdx++;
                                                }

                                                return (
                                                   <Draggable key={id} draggableId={id} index={idx}>
                                                      {(provided) => (
                                                         <li ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                            <BraineeQuestionCard
                                                               key={id}
                                                               index={idxCol[idx]}
                                                               id={idx}
                                                               type={type}
                                                               points={points}
                                                               correct={correct}
                                                               option_labels={option_labels}
                                                               image_url={image_url}
                                                               question_type={'1'}
                                                               mode={'create'}
                                                               parentCallback={handleCardRequest}
                                                               card_bg={location.state.card_bg}
                                                               assessment_type={'mastery'}
                                                            />
                                                         </li>
                                                      )}
                                                   </Draggable>
                                                );
                                             })}
                                             {provided.placeholder}
                                          </ul>
                                       )}
                                    </Droppable>
                                 </DragDropContext>

                                 <div ref={qtEndRef} />
                              </SimpleBarReact>
                           </div>
                        </>
                     }
                  </div>
               </div>
            </Split>
         </div>

         {/* <div className="dashboard-area">
            <div className="dashboard-item">
               <div className="dashboard-item-inner">
                  <ul>
                     <li><a href="#">Home</a></li>
                     <li><span>/</span></li>
                     <li><a href="#" onClick={() => navigate('/masteryassessment', {state: {activetab: "1"}})}>Mastery Assessments</a></li>
                     <li><span>/</span></li>
                     <li><a className="active" href="#">Create</a></li>
                  </ul>       
               </div>   
               
               <div className="pdf-all-page-container">
                  <SimpleBarReact>
                     <StickyBox style={{zIndex: 1000}}>
                        <div style={{textAlign: "right"}}>{UploadPdf()}</div>
                     </StickyBox>
                     {
                        questionSheetPDF === "" 
                           ? 
                           <Empty description="You have not yet uploaded your questionaire" style={{position:"relative"}} />
                           : 
                           <AllPagesPDFViewer pdf={questionSheetPDF}/>
                     }
                  </SimpleBarReact>
               </div>     
            </div>
         </div>

         <div className="notice-area" style={{display:"block"}}> 
            <div className="notice-item">
               
               {showAssessmentSheet &&  
                  <>
                     <div className='answer-sheet-content'>
                        <SimpleBarReact>
                           <StickyBox style={{zIndex: 1000}}>
                              <MasteryAssessmentTools 
                                 key={"createPDF"}
                                 data={assInfo} 
                                 cardRequestCallback={handleCardRequest} 
                                 saveCallback={handleSave} 
                                 showToggle={true} 
                                 mode={"create"} />
                           </StickyBox>
                        
                           <DragDropContext onDragEnd={(e) => handleOnDragEnd(e)}>
                              <Droppable droppableId="questions">
                                 {(provided) => (
                                    <ul className="questions" {...provided.droppableProps} ref={provided.innerRef}>
                                       {answerSheetData.map(({id, type, points, correct, option_labels, image_url}, idx) => { 

                                          if (type == "section") {
                                             qcardIdx = 1;
                                             idxCol.push(sectionIdx);
                                             sectionIdx++;
                                          } else {
                                             idxCol.push(qcardIdx);
                                             qcardIdx++;
                                          }                                    

                                          return (
                                             <Draggable key={id} draggableId={id} index={ idx }>
                                                {(provided) => (
                                                   <li ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                      <QuestionCard 
                                                         key={id}
                                                         index={ idxCol[idx] } 
                                                         id={idx} 
                                                         type={type} 
                                                         points={points} 
                                                         correct={correct} 
                                                         option_labels={option_labels} 
                                                         image_url={image_url}
                                                         question_type={'1'}
                                                         mode={'create'}
                                                         parentCallback={handleCardRequest} />                                          
                                                   </li>
                                                )}
                                             </Draggable>
                                          );
                                       })}
                                       {provided.placeholder}
                                    </ul>
                                 )}
                              </Droppable>
                           </DragDropContext>
                        </SimpleBarReact>
                     </div>
                  </>
               }
            </div>
         </div> */}
      </>
   )
}

